// extracted by mini-css-extract-plugin
export default {"swatch":"BaseSwatch_swatch__iHkwT","swatch__color":"BaseSwatch_swatch__color__Wy9ge","swatch__color-model":"BaseSwatch_swatch__color-model__D17ws"};